import React, { useEffect, useState } from 'react';
// import PropTypes from 'prop-types';
import { withRouter } from 'react-router'
import { path } from 'ramda'
import ReactMarkdown from 'react-markdown'
import { isLoggedIn, isAdmin, pathsChanged, ucFirst } from '../../common/ambient'
import { postAgentApi } from '../../common/ambient/awnAgent'
import bindAllActions from '../../common/bindAllActions'

function AiAgent({ user, history }) {
  const userChecked = path(['userChecked'], user)
  const [messages, setMessages] = useState([])
  const [inputValue, setInputValue] = useState('')
  const [conversationId, setConversationId] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!userChecked) return
    if (!isLoggedIn(user) && !isAdmin(user)) {
      history.replace('/dashboard')
    }
  }, [userChecked, user, history])

  const sendMessage = async () => {
    if (!inputValue.trim() || loading) return

    const userMessage = { type: 'user', text: inputValue }
    setMessages(prev => [...prev, userMessage])
    setLoading(true)

    try {
      const requestBody = { query: inputValue }
      if (conversationId) {
        requestBody.conversationId = conversationId
      }

      const response = await postAgentApi('query', requestBody)
      
      if (response.conversationId) {
        setConversationId(response.conversationId)
      }

      const aiMessage = { type: 'ai', text: response.response }
      setMessages(prev => [...prev, aiMessage])
    } catch (error) {
      console.error('Error sending message:', error)
      
      let errorText = 'Something went wrong. Please try again.'
      
      if (error.message) {
        if (error.message.includes('HTTP 401')) {
          errorText = 'Authentication failed. Please log in again.'
        } else if (error.message.includes('HTTP 403')) {
          errorText = 'Access denied. You may not have permission to use this feature.'
        } else if (error.message.includes('HTTP 500')) {
          errorText = 'Server error. Please try again later.'
        } else if (error.message.includes('HTTP 503')) {
          errorText = 'Service temporarily unavailable. Please try again later.'
        } else if (error.message.includes('Failed to fetch') || error.message.includes('NetworkError')) {
          errorText = 'Network error. Please check your internet connection.'
        } else if (error.message.includes('HTTP')) {
          errorText = `Server error: ${error.message}`
        }
      }
      
      const errorMessage = { type: 'error', text: errorText }
      setMessages(prev => [...prev, errorMessage])
    } finally {
      setLoading(false)
      setInputValue('')
    }
  }

  const clearConversation = () => {
    setMessages([])
    setConversationId(null)
    setInputValue('')
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    sendMessage()
  }

  return (
    <div className="user-ai-agent">
        <header className='main'>
          <h1>
            Cloudy 
          </h1>
        </header>
        <div className='page-body'>
          {conversationId && (
            <p className='text-right'>
              <a className='' onClick={clearConversation}>
                Clear Conversation
              </a>
            </p>
          )}
          <div className='chat-container'>
            <div className='messages'>
              {messages.map((message, index) => (
                <div key={index} className={`message ${message.type}`}>
                  <div className='message-content'>
                    {message.type === 'ai' ? (
                      <ReactMarkdown>{message.text}</ReactMarkdown>
                    ) : (
                      message.text
                    )}
                  </div>
                </div>
              ))}
              {loading && (
                <div className='message ai loading'>
                  <div className='message-content'>
                    Thinking...
                  </div>
                </div>
              )}
            </div>
            <form className='chat-input' onSubmit={handleSubmit}>
              <input
                type='text'
                className='form-control'
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                placeholder='Ask me anything...'
                disabled={loading}
              />
              <button className='btn btn-primary' type='submit' disabled={loading || !inputValue.trim()}>
                Send
              </button>
            </form>
          </div>
        </div>
    </div>
  );
};

export default bindAllActions(withRouter(AiAgent))
AiAgent.propTypes = {};
AiAgent.defaultProps = {};

AiAgent.displayName = 'AiAgent'
